<template>
  <div class="page" ref="pageEl" @scroll="updateScrollPosition">
    <navbar-conference></navbar-conference>
    <div class="loader disable" v-show="loader"></div>
    <router-view></router-view>
    <footer-conference></footer-conference>
  </div>
</template>

<script>
import NavbarConference from "./NavbarConference";
import FooterConference from "./FooterConference";

export default {
  components: {
    "navbar-conference": NavbarConference,
    "footer-conference": FooterConference,
  },
  data() {
    return {
      scrollPosition: 0
    };
  },
  watch: {
    async $route(query) {
      this.$refs.pageEl.scrollTop = 0;
    },
    scrollPosition(newValue, oldValue) {
      let isScrollTop
      if (newValue > oldValue) {
        isScrollTop = true;
      } else {
        isScrollTop = false;
      }
    }
  },
  computed: {
    loader() {
      return this.$store.state.loader;
    }
  },
  methods: {
    updateScrollPosition() {
      this.scrollPosition = this.$refs.pageEl.scrollTop;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../css/otherWebVariables";

.page {
  height: 100%;
  overflow-y: scroll;
  background: $color-background;
  font-size: $font-16;
}

@media screen and (max-width: $m-size) {
  .page {
    height: 100%;
    overflow-x: hidden;
    background: $color-background;
    font-size: $font-16;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/Conference/ConferenceLayout.vue